import React from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const AddRemoveMembersIcon = () => (
  <Icon tooltip="Add/Remove Members" iconObj={faUser} />
);

export default AddRemoveMembersIcon;